import React, { PropTypes } from 'react';
import SelectField from 'material-ui/SelectField';
import {MenuItem} from 'material-ui/Menu';
import ErrorContainer from '../../form/ErrorContainer';

class ClubSelector extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    fetch: PropTypes.func.isRequired,
    error: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.props.fetch()
  }

  render() {
    let {
      value,
      onChange,
      label,
      items
    } = this.props;

    if(items.length > 0) {
      return (
      <ErrorContainer displayLabel={false} {...this.props}>
        <SelectField
          value={value}
          onChange={(event, index, value) => onChange(value)}
          floatingLabelText={label}
          fullWidth={true}
        >
          {items.map((item, index) => (
            <MenuItem
              key={index}
              value={item.id}
              primaryText={item.name}
            />
          ))}
        </SelectField>
      </ErrorContainer>
      );
    } else {
      return (<div style={{marginTop: 14}}>There is no club</div>);
    }
  }
}

export default ClubSelector;




// WEBPACK FOOTER //
// ./src/components/Clubs/ClubSelector/component.jsx